<template>
  <div>
    <v-container fluid>
      <v-row>
        <!-- Panel de filtros y árbol -->
        <v-col cols="12" md="4" class="pa-2">
          <v-card v-if="viewMode === 'farms'">
            <v-card-title class="py-2">
              <v-icon left>mdi-map-search</v-icon>
              Filtros y Selección
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <sSelectedZona
                    label="Zona"
                    clearable
                    full
                    noDefault
                    v-model="selectedZoneId"
                    @input="loadSupervisorsWithFarms"
                  />
                </v-col>
                <v-col cols="12">
                  <s-select-definition
                    clearable
                    v-model="sizeType"
                    :def="1599"
                    label="Tamaño"
                    @change="loadSupervisorsWithFarms"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="searchText"
                    label="Buscar supervisor o fundo..."
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    dense
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-checkbox
                    :input-value="isAllVisibleSelected"
                    :indeterminate="isIndeterminateVisible"
                    @change="toggleSelectAllVisible"
                    color="primary"
                    dense
                    hide-details
                    label="Seleccionar todos los visibles"
                  />
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div v-if="loading" class="text-center pa-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <p class="mt-2">Cargando datos...</p>
              </div>

              <v-treeview
                v-else
                v-model="selectedFarmIds"
                :items="filteredTreeItems"
                :open.sync="openNodes"
                item-key="id"
                item-text="name"
                selectable
                return-object
                selection-type="leaf"
                dense
                class="pa-2"
                style="max-height: 65vh; overflow-y: auto"
                @input="onFarmSelectionChange"
              >
                <template v-slot:label="{ item }">
                  <div class="d-flex align-center">
                    <v-icon v-if="item.isSupervisor" :color="item.color" class="mr-2">
                      mdi-account-supervisor-circle
                    </v-icon>
                    <v-icon v-else :color="item.supervisorColor" class="mr-2">
                      mdi-map-marker-outline
                    </v-icon>
                    <span class="tree-label">{{ item.name }}</span>
                    <v-spacer></v-spacer>
                    <v-chip v-if="item.isSupervisor && item.farms" x-small class="ml-2">
                      {{ item.farms.length }}
                    </v-chip>
                  </div>
                </template>
              </v-treeview>
            </v-card-text>

            <!-- Footer de acciones removido por solicitud -->
          </v-card>

          <!-- VISTA DE LOTES -->
          <v-card v-else-if="viewMode === 'lots'">
            <v-card-title class="py-2">
              <v-btn icon @click="returnToFarmsMode" class="mr-2">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-icon left :color="currentFarm.supervisorColor">mdi-sprout</v-icon>
              Lotes en {{ currentFarm.name }}
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div v-if="loadingLots" class="text-center pa-4">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <p class="mt-2">Cargando lotes...</p>
              </div>
              <v-list dense style="max-height: 70vh; overflow-y: auto">
                <v-list-item-group
                  v-model="selectedLotIds"
                  multiple
                  @change="onSelectionChange"
                >
                  <v-list-item v-for="lot in currentLots" :key="lot.id" :value="lot">
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox :input-value="active" color="primary"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          lot.nombre || lot.name
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          {{ lot.FltHectares ? `${lot.FltHectares} ha` : "" }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon :color="lot.color || 'grey'">mdi-palette</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-chip color="blue" text-color="white" class="font-weight-bold">
                Seleccionados: {{ selectedLots.length }}
              </v-chip>
            </v-card-actions>
          </v-card>
        </v-col>

        <!-- Panel de mapa y rutas -->
        <v-col cols="12" md="8">
          <v-row>
            <!-- Información de la ruta -->
            <v-col cols="12" v-if="selectedCount > 0">
              <v-card color="blue-grey lighten-5" class="mb-2">
                <v-card-text class="py-2">
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-chip color="primary" small>
                        <v-icon left small>mdi-home-variant-outline</v-icon>
                        {{ selectedCount }} fundos
                      </v-chip>
                    </v-col>
                    <v-col cols="auto" v-if="routeInfo.distance > 0">
                      <v-chip color="success" small>
                        <v-icon left small>mdi-map-marker-path</v-icon>
                        {{ routeInfo.distance }} km
                      </v-chip>
                    </v-col>
                    <v-col cols="auto" v-if="routeInfo.estimatedTime > 0">
                      <v-chip color="orange" small>
                        <v-icon left small>mdi-clock-outline</v-icon>
                        {{ routeInfo.estimatedTime }} min
                      </v-chip>
                    </v-col>
                    <v-col cols="auto" v-if="routeLoading && useRoadRouting">
                      <v-chip color="info" small>
                        <v-progress-circular
                          indeterminate
                          size="12"
                          width="2"
                          class="mr-1"
                        ></v-progress-circular>
                        Calculando ruta...
                      </v-chip>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto">
                      <v-btn
                        small
                        color="success"
                        :disabled="routePoints.length === 0"
                        :loading="routeLoading"
                        @click="optimizeRoute"
                        class="mr-1"
                      >
                        <v-icon left small>mdi-auto-fix</v-icon>
                        Optimizar Ruta
                      </v-btn>
                      <v-btn
                        small
                        outlined
                        color="primary"
                        :disabled="routePoints.length === 0"
                        @click="recalculateRoute"
                        class="mr-1"
                      >
                        <v-icon left small>mdi-refresh</v-icon>
                        Recalcular
                      </v-btn>
                      <v-btn
                        small
                        text
                        color="error"
                        :disabled="routePoints.length === 0"
                        @click="clearRoute"
                      >
                        <v-icon left small>mdi-close</v-icon>
                        Limpiar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Mapa -->
            <v-col cols="12">
              <v-card
                :style="
                  selectedCount > 0
                    ? 'height: calc(100vh - 200px);'
                    : 'height: calc(100vh - 120px);'
                "
              >
                <v-card-title class="pb-2">
                  <v-icon left>mdi-map</v-icon>
                  Mapa de Rutas
                  <v-spacer />
                  <div class="d-flex align-center">
                    <v-btn
                      color="primary"
                      :disabled="selectedCount === 0"
                      :loading="routeLoading"
                      @click="calculateRoute"
                      class="mr-2"
                    >
                      <v-icon left>mdi-routes</v-icon>
                      Trazar Ruta
                    </v-btn>
                    <v-switch
                      v-model="includeReturnTrip"
                      label="Desde planta"
                      color="orange"
                      dense
                      class="mt-0 mr-4"
                    />
                    <v-switch
                      v-model="useRoadRouting"
                      label="Ruta carretera"
                      color="indigo"
                      dense
                      class="mt-0"
                    />
                  </div>
                </v-card-title>

                <v-card-text class="pa-0" style="height: calc(100% - 64px)">
                  <div id="lotMap" style="height: 100%; width: 100%"></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import _sFarmLot from "@/services/Technicalassistance/FarmLotService.js";
import _sSupervisor from "@/services/Technicalassistance/TasAgriculturalFarmResponsibleSupervisor/TasAgriculturalFarmResponsibleSupervisorService.js";
import _sAgriculturalFarm from "@/services/Technicalassistance/AgriculturalFarmsService.js";
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";

// Fix iconos Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "LotRouteSelector",
  components: {
    sSelectedZona,
  },

  data() {
    return {
      map: null,
      selectedZoneId: null,
      sizeType: null,
      searchText: "",
      allSupervisors: [],
      allFarms: [],
      treeItems: [],
      filteredTreeItems: [],
      selectedFarmIds: [],
      selectedFarms: [],
      openNodes: [],
      loading: false,
      routeLoading: false,
      loadingLots: false,
      viewMode: "farms", // 'farms' o 'lots'
      currentFarm: null,
      currentLots: [],
      selectedLotIds: [],
      selectedLots: [],

      // Mapa
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      tileAttribution: "© Stadia Maps | © OpenStreetMap",
      mapCenter: [-4.9005, -80.3314], // Centro en Piura (planta Sunshine)
      mapZoom: 11,

      // Marcadores y capas
      markersLayer: null,
      routeLayer: null,
      polygonsLayer: null, // Capa para polígonos de fundos
      lotMarkersLayer: null, // Capa para marcadores de lotes
      lotsPolygonsLayer: null, // Capa para polígonos de lotes

      // Límite de selección
      maxSelection: Infinity,

      // Ruta manual
      routePoints: [],
      routeInfo: {
        distance: 0,
        estimatedTime: 0,
      },

      // Punto de inicio/fin (Planta Sunshine)
      sunshinePoint: {
        id: "sunshine",
        name: "SUNSHINE EXPORT S.A.C.",
        lat: -4.9005, // Coordenadas actualizadas desde MapsSunExpert
        lng: -80.3314,
        isPlant: true,
      },
      includeReturnTrip: true, // Incluir ida y vuelta desde la planta

      // Configuración de routing
      useRoadRouting: true, // Usar rutas por carretera en lugar de líneas rectas

      // Paleta de colores para supervisores
      supervisorColors: [
        "#FF6B35",
        "#F7931E",
        "#FFD23F",
        "#06FFA5",
        "#118AB2",
        "#073B4C",
        "#8E44AD",
        "#E74C3C",
        "#2ECC71",
        "#F39C12",
        "#9B59B6",
        "#3498DB",
        "#1ABC9C",
        "#34495E",
        "#E67E22",
        "#95A5A6",
        "#16A085",
        "#27AE60",
        "#2980B9",
        "#8E44AD",
        "#C0392B",
        "#D35400",
        "#7F8C8D",
        "#2C3E50",
        "#F1C40F",
        "#E67E22",
        "#1ABC9C",
        "#9B59B6",
        "#3498DB",
        "#E74C3C",
        "#FF8C00",
        "#00BFFF",
        "#ADFF2F",
        "#FF1493",
        "#8B4513",
        "#40E0D0",
        "#DC143C",
        "#B0E0E6",
        "#228B22",
        "#DA70D6",
        "#CD5C5C",
        "#FFD700",
        "#4169E1",
        "#20B2AA",
        "#9370DB",
        "#708090",
        "#FF4500",
        "#3CB371",
        "#5F9EA0",
        "#B22222",
        "#808000",
      ],
      supervisorColorMap: new Map(), // Mapeo PrsID -> Color

      // Selección guardada (persistente)
      savedFarms: [],
    };
  },

  computed: {
    selectedCount() {
      return this.selectedFarms.length;
    },
    // Lista de fundos visibles según el filtro actual
    visibleFarms() {
      const farms = [];
      const walk = (nodes) => {
        (nodes || []).forEach((n) => {
          if (n.isSupervisor && n.children) {
            walk(n.children);
          } else if (!n.isSupervisor) {
            farms.push(n);
          }
        });
      };
      walk(this.filteredTreeItems || []);
      return farms;
    },
    selectedVisibleCount() {
      const set = new Set(this.selectedFarms.map((f) => f.fagId));
      return this.visibleFarms.filter((f) => set.has(f.fagId)).length;
    },
    isAllVisibleSelected() {
      return (
        this.visibleFarms.length > 0 &&
        this.selectedVisibleCount === this.visibleFarms.length
      );
    },
    isIndeterminateVisible() {
      return this.selectedVisibleCount > 0 && !this.isAllVisibleSelected;
    },
  },

  watch: {
    searchText: {
      handler: "filterSupervisors",
      immediate: false,
    },
  },

  mounted() {
    this.initializeMap();
    this.loadSupervisorsWithFarms();
  },

  methods: {
    // Dibuja el contorno del fundo actual sin afectar los polígonos de lotes
    async drawCurrentFarmOutline(farm) {
      try {
        if (!farm) return;
        // Limpiar solo la capa de contornos de fundos
        this.polygonsLayer.clearLayers();
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        const response = await _sAgriculturalFarm.getFarmGeometryGeoJSON(farm.fagId, uid);
        const fc = response && response.data;
        const hasFeatures = !!(
          fc &&
          ((fc.type === "FeatureCollection" && fc.features && fc.features.length > 0) ||
            fc.type === "Feature" ||
            fc.type === "Polygon" ||
            fc.type === "MultiPolygon")
        );
        if (!hasFeatures) return;
        const outline = L.geoJSON(fc, {
          style: {
            color: farm.supervisorColor || "#2196f3",
            weight: 3,
            dashArray: "8,4",
            fillOpacity: 0.03,
            opacity: 0.95,
          },
        });

        // Agregar tooltip con área y perímetro al contorno del fundo
        outline.eachLayer((layer) => {
          let areaTxt = "";
          let perimeterTxt = "";
          try {
            const latlngs = layer.getLatLngs();
            const normalize = (arr) => {
              if (!arr || arr.length === 0) return [];
              return typeof arr[0].lat === "number" ? [arr] : arr;
            };
            const polys = normalize(latlngs);

            // Calcular área geodésica
            let totalArea = 0;
            for (const ring of polys) {
              if (ring && ring.length >= 3) {
                const R = 6371000;
                let area = 0;
                for (let i = 0; i < ring.length; i++) {
                  const p1 = ring[i];
                  const p2 = ring[(i + 1) % ring.length];
                  const lat1 = (p1.lat * Math.PI) / 180;
                  const lat2 = (p2.lat * Math.PI) / 180;
                  const lng1 = (p1.lng * Math.PI) / 180;
                  const lng2 = (p2.lng * Math.PI) / 180;
                  area += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                }
                totalArea += Math.abs((area * R * R) / 2);
              }
            }
            areaTxt = totalArea > 0 ? `${(totalArea / 10000).toFixed(4)} ha` : "";

            // Calcular perímetro geodésico
            let totalPerimeter = 0;
            for (const ring of polys) {
              if (ring && ring.length >= 2) {
                for (let i = 0; i < ring.length; i++) {
                  const p1 = L.latLng(ring[i].lat, ring[i].lng);
                  const p2 = L.latLng(
                    ring[(i + 1) % ring.length].lat,
                    ring[(i + 1) % ring.length].lng
                  );
                  totalPerimeter += p1.distanceTo(p2);
                }
              }
            }
            perimeterTxt = totalPerimeter > 0 ? `${totalPerimeter.toFixed(2)} m` : "";
          } catch (_) {}

          const tooltipContent = [
            `<strong>${farm.name}</strong>`,
            `(Contorno del fundo)`,
            areaTxt ? `Área: ${areaTxt}` : "",
            perimeterTxt ? `Perímetro: ${perimeterTxt}` : "",
          ]
            .filter(Boolean)
            .join("<br/>");

          layer.bindTooltip(tooltipContent, {
            sticky: true,
            className: "farm-polygon-tooltip",
          });
        });

        this.polygonsLayer.addLayer(outline);
      } catch (e) {
        console.warn("No se pudo dibujar contorno del fundo actual:", e);
      }
    },
    // Seleccionar / deseleccionar todos los fundos visibles
    toggleSelectAllVisible(value) {
      const byId = new Map(this.selectedFarms.map((f) => [f.fagId, f]));
      if (value) {
        // Agregar todos los visibles
        this.visibleFarms.forEach((f) => byId.set(f.fagId, f));
        // Abrir automáticamente los supervisores que contienen visibles
        const toOpen = [];
        (this.filteredTreeItems || []).forEach((n) => {
          if (n.isSupervisor && n.children && n.children.length > 0) {
            toOpen.push(n.id);
          }
        });
        this.openNodes = Array.from(new Set([...(this.openNodes || []), ...toOpen]));
      } else {
        // Quitar todos los visibles
        this.visibleFarms.forEach((f) => byId.delete(f.fagId));
      }
      this.selectedFarms = Array.from(byId.values());
      this.selectedFarmIds = [...this.selectedFarms];
      this.updateMapMarkers();
      this.adjustMapViewToSelection();
      this.loadSelectedFarmPolygons();
    },
    initializeMap() {
      this.map = L.map("lotMap").setView(this.mapCenter, this.mapZoom);

      L.tileLayer(this.tileUrl, {
        attribution: this.tileAttribution,
        maxZoom: 19,
      }).addTo(this.map);

      this.markersLayer = L.layerGroup().addTo(this.map);
      this.routeLayer = L.layerGroup().addTo(this.map);
      this.polygonsLayer = L.layerGroup().addTo(this.map);
      this.lotsPolygonsLayer = L.layerGroup().addTo(this.map);
    },

    // Alternar selección de un fundo desde el mapa
    toggleFarmSelection(farm) {
      const exists = this.selectedFarms.some((f) => f.fagId === farm.fagId);
      if (exists) {
        this.selectedFarms = this.selectedFarms.filter((f) => f.fagId !== farm.fagId);
      } else {
        this.selectedFarms = [...this.selectedFarms, farm];
      }
      // Sincronizar con el árbol (retorna objetos)
      this.selectedFarmIds = [...this.selectedFarms];
      this.updateMapMarkers();
      this.adjustMapViewToSelection();
      this.loadSelectedFarmPolygons();
    },

    async loadSupervisorsWithFarms() {
      if (this.loading) return;

      this.loading = true;
      try {
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;

        const response = await _sSupervisor.getSupervisorsWithFarms(
          uid,
          this.selectedZoneId,
          this.sizeType
        );

        let supervisorsData = [];
        if (Array.isArray(response.data)) {
          supervisorsData = response.data;
        } else if (Array.isArray(response)) {
          supervisorsData = response;
        } else {
          console.warn("⚠️ Estructura de respuesta inesperada:", response);
        }

        // Procesar datos
        this.processSupervisorsData(supervisorsData);
        this.buildSupervisorTree();
        this.updateMapFarmPolygons();
        this.filterSupervisors();
      } catch (error) {
        console.error("❌ Error loading supervisors with farms:", error);
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("Error al cargar supervisores y fundos", "error");
      } finally {
        this.loading = false;
      }
    },

    processSupervisorsData(data) {
      // Limpiar mapas
      this.supervisorColorMap.clear();
      const supervisorMap = new Map();
      let colorIndex = 0;

      // Procesar datos y agrupar por supervisor
      data.forEach((item) => {
        const supervisorId = item.PrsID;
        const supervisorName = item.SupervisorName;

        // Asignar color al supervisor si no lo tiene
        if (!this.supervisorColorMap.has(supervisorId)) {
          const color = this.supervisorColors[colorIndex % this.supervisorColors.length];
          this.supervisorColorMap.set(supervisorId, color);
          colorIndex++;
        }

        // Agregar supervisor al mapa
        if (!supervisorMap.has(supervisorId)) {
          supervisorMap.set(supervisorId, {
            id: `supervisor_${supervisorId}`,
            prsId: supervisorId,
            name: supervisorName,
            isSupervisor: true,
            color: this.supervisorColorMap.get(supervisorId),
            farms: [],
          });
        }

        // Validar coordenadas del fundo
        const hasCoords =
          item.FagLatitude &&
          item.FagLength &&
          item.FagLatitude !== "" &&
          item.FagLength !== "" &&
          !isNaN(parseFloat(item.FagLatitude)) &&
          !isNaN(parseFloat(item.FagLength));

        if (hasCoords) {
          // Agregar fundo al supervisor
          const farm = {
            id: item.FagID,
            fagId: item.FagID,
            name: item.FagName,
            isSupervisor: false,
            supervisorId: supervisorId,
            supervisorColor: this.supervisorColorMap.get(supervisorId),
            lat: parseFloat(item.FagLatitude),
            lng: parseFloat(item.FagLength),
            coordinates: true,
            areaGeom: item.FltAreaGeom,
            areaAll: item.AreaAll,
            zonDescription: item.ZonDescription,
            raw: item,
          };

          supervisorMap.get(supervisorId).farms.push(farm);
        }
      });

      // Convertir a arrays
      this.allSupervisors = Array.from(supervisorMap.values());
      this.allFarms = this.allSupervisors.flatMap((s) => s.farms);
    },

    // Alias para compatibilidad
    loadLots() {
      this.loadSupervisorsWithFarms();
    },

    buildSupervisorTree() {
      if (!this.allSupervisors || this.allSupervisors.length === 0) {
        this.treeItems = [];
        return;
      }

      this.treeItems = this.allSupervisors.map((supervisor) => ({
        ...supervisor,
        children: supervisor.farms.map((farm) => ({
          ...farm,
          supervisorColor: supervisor.color,
        })),
      }));
    },
    // buildTree method replaced by buildSupervisorTree

    filterSupervisors() {
      if (!this.searchText) {
        this.filteredTreeItems = [...this.treeItems];
        return;
      }

      const searchLower = this.searchText.toLowerCase();

      this.filteredTreeItems = this.treeItems
        .map((supervisor) => {
          const supervisorMatches = supervisor.name.toLowerCase().includes(searchLower);
          const matchingFarms = (supervisor.children || []).filter((farm) =>
            farm.name.toLowerCase().includes(searchLower)
          );

          if (supervisorMatches || matchingFarms.length > 0) {
            return {
              ...supervisor,
              children: supervisorMatches ? supervisor.children : matchingFarms,
            };
          }
          return null;
        })
        .filter(Boolean);
    },

    onFarmSelectionChange(selectedItems) {
      // Filtrar solo fundos (no supervisores)
      let validFarms = selectedItems.filter(
        (item) => !item.isSupervisor && item.coordinates
      );

      this.selectedFarms = validFarms;

      if (validFarms.length === 0) {
        this.clearRoute();
      }

      this.selectedFarmIds = validFarms;
      this.updateMapMarkers();
      this.adjustMapViewToSelection();
      this.loadSelectedFarmPolygons();
    },

    async updateMapFarmPolygons() {
      if (!this.polygonsLayer) return;

      this.polygonsLayer.clearLayers();

      if (this.allFarms.length === 0) return;

      const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;

      for (const farm of this.allFarms) {
        try {
          const response = await _sAgriculturalFarm.getFarmGeometryGeoJSON(
            farm.fagId,
            uid
          );

          if (response && response.data) {
            const fc = response.data;

            const hasFeatures = !!(
              fc &&
              ((fc.type === "FeatureCollection" &&
                fc.features &&
                fc.features.length > 0) ||
                fc.type === "Feature" ||
                fc.type === "Polygon" ||
                fc.type === "MultiPolygon")
            );

            if (hasFeatures) {
              const isSelected =
                this.selectedFarms.some((selected) => selected.fagId === farm.fagId) ||
                (this.savedFarms &&
                  this.savedFarms.some((sf) => sf.fagId === farm.fagId));

              const isCurrentInLots =
                this.viewMode === "lots" &&
                this.currentFarm &&
                this.currentFarm.fagId === farm.fagId;
              const stroke = farm.supervisorColor || "#2196f3";
              const fill = this.lightenColor ? this.lightenColor(stroke, 35) : stroke;
              const polygonLayer = L.geoJSON(fc, {
                style: {
                  color: stroke,
                  weight: isSelected ? 3 : 2,
                  dashArray: isCurrentInLots ? "8,4" : null,
                  fillColor: fill,
                  fillOpacity: isSelected ? 0.18 : 0.08,
                  opacity: 0.95,
                },
              });

              // Agregar tooltip con cálculos geodésicos
              polygonLayer.eachLayer((layer) => {
                let areaTxt = "";
                let perimeterTxt = "";
                try {
                  const latlngs = layer.getLatLngs();
                  const normalize = (arr) => {
                    if (!arr || arr.length === 0) return [];
                    return typeof arr[0].lat === "number" ? [arr] : arr;
                  };
                  const polys = normalize(latlngs);

                  // Calcular área geodésica
                  let totalArea = 0;
                  for (const ring of polys) {
                    if (ring && ring.length >= 3) {
                      const R = 6371000;
                      let area = 0;
                      for (let i = 0; i < ring.length; i++) {
                        const p1 = ring[i];
                        const p2 = ring[(i + 1) % ring.length];
                        const lat1 = (p1.lat * Math.PI) / 180;
                        const lat2 = (p2.lat * Math.PI) / 180;
                        const lng1 = (p1.lng * Math.PI) / 180;
                        const lng2 = (p2.lng * Math.PI) / 180;
                        area += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                      }
                      totalArea += Math.abs((area * R * R) / 2);
                    }
                  }
                  areaTxt = totalArea > 0 ? `${(totalArea / 10000).toFixed(4)} ha` : "";

                  // Calcular perímetro geodésico
                  let totalPerimeter = 0;
                  for (const ring of polys) {
                    if (ring && ring.length >= 2) {
                      for (let i = 0; i < ring.length; i++) {
                        const p1 = L.latLng(ring[i].lat, ring[i].lng);
                        const p2 = L.latLng(
                          ring[(i + 1) % ring.length].lat,
                          ring[(i + 1) % ring.length].lng
                        );
                        totalPerimeter += p1.distanceTo(p2);
                      }
                    }
                  }
                  perimeterTxt =
                    totalPerimeter > 0 ? `${totalPerimeter.toFixed(2)} m` : "";
                } catch (_) {}

                const tooltipContent = [
                  `<strong>${farm.name}</strong>`,
                  `Supervisor: ${this.getSupervisorName(farm.supervisorId)}`,
                  farm.areaAll ? `Área total lotes: ${farm.areaAll} ha` : "",
                  areaTxt ? `Área calculada: ${areaTxt}` : "",
                  perimeterTxt ? `Perímetro: ${perimeterTxt}` : "",
                  farm.zonDescription ? `Zona: ${farm.zonDescription}` : "",
                ]
                  .filter(Boolean)
                  .join("<br/>");

                layer.bindTooltip(tooltipContent, {
                  sticky: true,
                  className: "farm-polygon-tooltip",
                });

                // Manejar doble clic directamente en el layer
                layer.on("dblclick", (e) => {
                  if (e && e.originalEvent) {
                    e.originalEvent.preventDefault && e.originalEvent.preventDefault();
                    e.originalEvent.stopPropagation && e.originalEvent.stopPropagation();
                  }
                  // Preferir el id proveniente del feature clicado si existe
                  const clickedId =
                    (e &&
                      e.sourceTarget &&
                      e.sourceTarget.feature &&
                      e.sourceTarget.feature.properties &&
                      (e.sourceTarget.feature.properties.fagId ||
                        e.sourceTarget.feature.properties.FagID ||
                        e.sourceTarget.feature.properties.id)) ||
                    farm.fagId;
                  const clickedFarm =
                    this.allFarms.find((f) => f.fagId === clickedId) || farm;
                  // console.log("🖱️ dblclick farm -> id:", clickedId, "name:", clickedFarm.name);
                  this.onFarmDoubleClick(clickedFarm);
                });

                // Agregar un checkbox flotante en el centro del polígono para seleccionar
                try {
                  const center = layer.getBounds().getCenter();
                  const isSel = this.selectedFarms.some((s) => s.fagId === farm.fagId);
                  const checkIcon = L.divIcon({
                    className: "farm-check-container",
                    html: `<div class="farm-check ${isSel ? "is-checked" : ""}">
                             <input type="checkbox" ${isSel ? "checked" : ""} />
                           </div>`,
                    iconSize: [22, 22],
                    iconAnchor: [11, 11],
                  });
                  const checkMarker = L.marker(center, {
                    icon: checkIcon,
                    interactive: true,
                  });
                  checkMarker.on("click", (e) => {
                    if (e && e.originalEvent) {
                      e.originalEvent.preventDefault && e.originalEvent.preventDefault();
                      e.originalEvent.stopPropagation &&
                        e.originalEvent.stopPropagation();
                    }
                    this.toggleFarmSelection(farm);
                  });
                  checkMarker.bindTooltip("Seleccionar/deseleccionar fundo", {
                    direction: "top",
                    offset: [0, -10],
                  });
                  this.polygonsLayer.addLayer(checkMarker);
                } catch (err) {
                  console.warn("No se pudo colocar checkbox en polígono:", err);
                }
              });
              // (el dblclick ahora se maneja por layer para evitar conflictos con stopPropagation)

              this.polygonsLayer.addLayer(polygonLayer);
            }
          }
        } catch (error) {
          console.warn(`❌ Error cargando polígono del fundo ${farm.name}:`, error);
        }
      }
    },

    getSupervisorName(supervisorId) {
      const supervisor = this.allSupervisors.find((s) => s.prsId === supervisorId);
      return supervisor ? supervisor.name : "Desconocido";
    },

    async onFarmDoubleClick(farm) {
      if (!farm || !farm.fagId) return;
      this.currentFarm = farm;
      this.viewMode = "lots";
      this.selectedLotIds = [];
      this.selectedLots = [];
      await this.loadFarmLots(farm.fagId);
      this.$fun &&
        this.$fun.toast &&
        this.$fun.toast(`Lotes de ${farm.name} cargados`, "info");
      this.map.setView([farm.lat, farm.lng], 15);
    },

    async loadFarmLots(fagId) {
      if (this.loadingLots) return;
      this.loadingLots = true;
      this.currentLots = [];

      try {
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        const response = await _sFarmLot.getListMin(uid, fagId);

        let lots = [];
        if (Array.isArray(response.data)) {
          lots = response.data;
        } else if (Array.isArray(response)) {
          lots = response;
        }

        // Filtrar lotes con coordenadas válidas
        const validLots = lots
          .map((lot) => {
            if (lot.Wkt && typeof lot.Wkt === "string" && lot.Wkt.includes("(")) {
              try {
                // Extraer las coordenadas del primer punto del WKT
                const coordsString = lot.Wkt.substring(lot.Wkt.indexOf("(") + 1)
                  .split(",")[0]
                  .trim();
                const coords = coordsString.replace("(", "").replace(")", "").split(" ");

                const lon = parseFloat(coords[0]);
                const lat = parseFloat(coords[1]);

                if (!isNaN(lat) && !isNaN(lon)) {
                  return { ...lot, lat, lon };
                }
              } catch (e) {
                console.warn(
                  `Lote "${lot.nombre || lot.Name}" tiene un WKT inválido.`,
                  lot.Wkt
                );
                return null;
              }
            }
            // Fallback para la estructura anterior con lat/lon directos
            if (
              lot.lat &&
              lot.lon &&
              !isNaN(parseFloat(lot.lat)) &&
              !isNaN(parseFloat(lot.lon))
            ) {
              return lot;
            }

            console.warn(
              `Lote "${
                lot.nombre || lot.Name
              }" descartado por falta de coordenadas o WKT.`
            );
            return null;
          })
          .filter(Boolean); // Filtrar los lotes nulos (inválidos)

        this.currentLots = await Promise.all(
          validLots.map(async (lot) => {
            let detailedLot = { ...lot };
            try {
              // Obtener detalles del lote para asegurar el nombre correcto
              const detailResponse = await _sFarmLot.getLot(lot.id || lot.Id, uid);
              if (detailResponse && detailResponse.data) {
                detailedLot.FltName = detailResponse.data.FltName;
              }
            } catch (e) {
              console.warn(`No se pudo obtener detalle para lote ${lot.id}`, e);
            }
            return {
              ...detailedLot,
              id: lot.id || lot.Id,
              name: detailedLot.FltName || lot.nombre || lot.Name,
              level: lot.nivel || lot.Nivel,
              parentId: lot.loteId || lot.LoteId,
              coordinates: true,
            };
          })
        );

        // Dibujar polígonos de lotes (no puntos)
        await this.drawLotsPolygons(this.currentLots);
      } catch (error) {
        console.error("❌ Error cargando lotes del fundo:", error);
        this.currentLots = [];
      } finally {
        this.loadingLots = false;
      }
    },

    // Dibuja los polígonos de los lotes del fundo actual
    async drawLotsPolygons(lots) {
      if (!this.lotsPolygonsLayer) return;
      this.lotsPolygonsLayer.clearLayers();
      const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
      const color =
        this.currentFarm && this.currentFarm.supervisorColor
          ? this.currentFarm.supervisorColor
          : "#2196f3";
      const group = L.featureGroup();

      let idx = 0;
      const total = Math.max(1, lots.length - 1);
      for (const lot of lots) {
        try {
          const resp = await _sFarmLot.getLotGeometryGeoJSONById(lot.id, uid);
          const fc = resp && resp.data;
          const hasGeom = !!(
            fc &&
            ((fc.type === "FeatureCollection" && fc.features && fc.features.length > 0) ||
              fc.type === "Feature" ||
              fc.type === "Polygon" ||
              fc.type === "MultiPolygon")
          );
          if (!hasGeom) continue;
          const t = total === 0 ? 0.5 : idx / total;
          const fillColor = this.lightenColor
            ? this.lightenColor(color, 20 + Math.round(t * 35))
            : color;
          const strokeColor = this.darkenColor ? this.darkenColor(color, 10) : color;
          const poly = L.geoJSON(fc, {
            style: {
              color: strokeColor,
              weight: 2,
              opacity: 0.95,
              fillColor: fillColor,
              fillOpacity: 0.4,
            },
          });
          poly.on("click", () => {
            this.onLotClick(lot);
          });

          // Tooltip informativo con área y perímetro geodésicos
          poly.eachLayer((layer) => {
            let areaTxt = "";
            let perimeterTxt = "";
            try {
              const latlngs = layer.getLatLngs();
              const normalize = (arr) => {
                if (!arr || arr.length === 0) return [];
                return typeof arr[0].lat === "number" ? [arr] : arr;
              };
              const polys = normalize(latlngs);

              // Calcular área geodésica
              let totalArea = 0;
              for (const ring of polys) {
                if (ring && ring.length >= 3) {
                  // Fórmula esférica para área
                  const R = 6371000;
                  let area = 0;
                  for (let i = 0; i < ring.length; i++) {
                    const p1 = ring[i];
                    const p2 = ring[(i + 1) % ring.length];
                    const lat1 = (p1.lat * Math.PI) / 180;
                    const lat2 = (p2.lat * Math.PI) / 180;
                    const lng1 = (p1.lng * Math.PI) / 180;
                    const lng2 = (p2.lng * Math.PI) / 180;
                    area += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                  }
                  totalArea += Math.abs((area * R * R) / 2);
                }
              }
              areaTxt = totalArea > 0 ? `${(totalArea / 10000).toFixed(4)} ha` : "";

              // Calcular perímetro geodésico
              let totalPerimeter = 0;
              for (const ring of polys) {
                if (ring && ring.length >= 2) {
                  for (let i = 0; i < ring.length; i++) {
                    const p1 = L.latLng(ring[i].lat, ring[i].lng);
                    const p2 = L.latLng(
                      ring[(i + 1) % ring.length].lat,
                      ring[(i + 1) % ring.length].lng
                    );
                    totalPerimeter += p1.distanceTo(p2);
                  }
                }
              }
              perimeterTxt = totalPerimeter > 0 ? `${totalPerimeter.toFixed(2)} m` : "";
            } catch (_) {}

            const title = [
              `<strong>${lot.nombre || lot.name}</strong>`,
              lot.FltHectares ? `Hectáreas registradas: ${lot.FltHectares}` : "",
              areaTxt ? `Área calculada: ${areaTxt}` : "",
              perimeterTxt ? `Perímetro: ${perimeterTxt}` : "",
            ]
              .filter(Boolean)
              .join("<br/>");
            layer.bindTooltip(title, {
              sticky: true,
              className: "lot-polygon-tooltip",
            });
          });
          this.lotsPolygonsLayer.addLayer(poly);
          group.addLayer(poly);
          idx++;
        } catch (err) {
          console.warn("No se pudo dibujar polígono de lote", lot.name, err);
        }
      }
      // Ajustar vista si hay geometrías
      try {
        const b = group.getBounds();
        if (b && b.isValid && b.isValid()) {
          this.map.fitBounds(b, { padding: [30, 30], maxZoom: 16 });
        }
      } catch (_) {}
    },

    addLotMarkers(lots) {
      // Limpiar marcadores anteriores de lotes
      if (this.lotMarkersLayer) {
        this.lotMarkersLayer.clearLayers();
      } else {
        this.lotMarkersLayer = L.layerGroup().addTo(this.map);
      }

      lots.forEach((lot) => {
        const lat = parseFloat(lot.lat);
        const lng = parseFloat(lot.lon);

        const marker = L.circleMarker([lat, lng], {
          radius: 6,
          fillColor: "#FF5722",
          color: "#D32F2F",
          weight: 2,
          opacity: 1,
          fillOpacity: 0.8,
        });

        marker.bindTooltip(
          `
          <strong>${lot.nombre || lot.name}</strong><br/>
          Lote ID: ${lot.id}<br/>
          Nivel: ${lot.level}<br/>
          <em>Haz clic para seleccionar</em>
        `,
          { sticky: true }
        );

        marker.on("click", () => {
          this.onLotClick(lot);
        });

        this.lotMarkersLayer.addLayer(marker);
      });
    },

    onLotClick(lot) {
      console.log("📍 Clic en lote:", lot.nombre || lot.name);
      // Aquí podrías agregar el lote a la selección para rutas
      // O mostrar información detallada
    },

    loadSelectedFarmPolygons() {
      // En vista de lotes, mantener contorno del fundo actual
      if (this.viewMode === "lots" && this.currentFarm) {
        this.drawCurrentFarmOutline(this.currentFarm);
      } else {
        // Vista de fundos: recargar todos
        this.updateMapFarmPolygons();
      }
    },

    returnToFarmsMode() {
      this.viewMode = "farms";
      if (this.lotMarkersLayer) {
        this.lotMarkersLayer.clearLayers();
      }
      if (this.lotsPolygonsLayer) {
        this.lotsPolygonsLayer.clearLayers();
      }
      this.polygonsLayer.clearLayers();
      this.selectedLots = [];
      this.selectedLotIds = [];
      this.updateMapFarmPolygons();
      this.$fun && this.$fun.toast && this.$fun.toast("Volviendo al modo fundos", "info");
    },

    onSelectionChange(selectedItems) {
      // Filtrar solo items con coordenadas
      let validSelections = selectedItems.filter((item) => item.coordinates);

      // Aplicar lógica padre-hijo: si seleccionas un padre, quitar hijos; si seleccionas hijo, quitar padre
      validSelections = this.applyParentChildLogic(validSelections);

      this.selectedLots = validSelections;

      // Solo limpiar ruta si no hay lotes seleccionados
      if (validSelections.length === 0) {
        this.clearRoute();
      }

      // Actualizar selectedLotIds para reflejar los cambios de lógica padre-hijo
      this.selectedLotIds = validSelections;

      this.updateMapMarkers();

      // Ajustar vista para mostrar lotes seleccionados
      this.adjustMapViewToSelection();

      // Cargar polígonos de lotes seleccionados
      this.loadSelectedLotPolygons();
    },

    // Carga los polígonos de los lotes seleccionados
    async loadSelectedLotPolygons() {
      if (!this.polygonsLayer) return;

      // Limpiar polígonos anteriores
      this.polygonsLayer.clearLayers();

      if (this.selectedLots.length === 0) return;

      const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;

      for (const lot of this.selectedLots) {
        try {
          const response = await _sFarmLot.getLotGeometryGeoJSONById(lot.id, uid);

          if (response && response.data) {
            const fc = response.data;

            // Verificar que hay features válidas
            const hasFeatures = !!(
              fc &&
              ((fc.type === "FeatureCollection" &&
                fc.features &&
                fc.features.length > 0) ||
                fc.type === "Feature" ||
                fc.type === "Polygon" ||
                fc.type === "MultiPolygon")
            );

            if (hasFeatures) {
              // Determinar si está en la ruta para usar color diferente
              const isInRoute = this.routePoints.some((point) => point.id === lot.id);

              const polygonLayer = L.geoJSON(fc, {
                style: {
                  color: lot.color || (isInRoute ? "#ff5722" : "#2196f3"),
                  weight: 2,
                  fillOpacity: isInRoute ? 0.3 : 0.2,
                  opacity: 0.8,
                },
              });

              // Agregar tooltip con información del lote
              polygonLayer.eachLayer((layer) => {
                try {
                  // Calcular área del polígono si es posible
                  let areaTxt = "";
                  try {
                    const latlngs = layer.getLatLngs();
                    const rings = Array.isArray(latlngs[0]) ? latlngs[0] : latlngs;

                    if (L.GeometryUtil && L.GeometryUtil.geodesicArea) {
                      const total = L.GeometryUtil.geodesicArea(rings[0] || rings);
                      areaTxt = total > 0 ? `${(total / 10000).toFixed(2)} ha` : "";
                    }
                  } catch (areaError) {
                    console.warn("Error calculando área:", areaError);
                  }

                  const tooltipContent = [
                    `<strong>${lot.name}</strong>`,
                    `Nivel: ${lot.level === 1 ? "Lote" : "Sublote"}`,
                    areaTxt ? `Área: ${areaTxt}` : "",
                    //isInRoute ? `<strong>En ruta: Sí</strong>` : `<em>Seleccionado</em>`,
                    lot.CultiveText ? `Cultivo: ${lot.CultiveText}` : "",
                    lot.FltHectares ? `Hectáreas: ${lot.FltHectares}` : "",
                    lot.FltPlants ? `N° Plantas: ${lot.FltPlants}` : "",
                  ]
                    .filter(Boolean)
                    .join("<br/>");

                  layer.bindTooltip(tooltipContent, { sticky: true });

                  layer.on("mouseover", () => {
                    try {
                      layer.openTooltip();
                    } catch (_) {}
                  });
                } catch (error) {
                  console.warn("Error procesando tooltip del polígono:", error);
                }
              });

              this.polygonsLayer.addLayer(polygonLayer);
            } else {
              this.$fun &&
                this.$fun.toast &&
                this.$fun.toast(`Lote sin geometría: ${lot.name}`, "warning");
            }
          }
        } catch (error) {
          console.warn(`❌ Error cargando polígono del lote ${lot.name}:`, error);
        }
      }
    },

    // Aplica lógica para evitar selección simultánea de padre e hijo
    applyParentChildLogic(selectedItems) {
      const result = [];
      const processed = new Set();

      selectedItems.forEach((item) => {
        if (processed.has(item.id)) return;

        if (item.level === 1) {
          // Es un lote padre, quitar todos sus hijos de la selección
          result.push(item);
          processed.add(item.id);

          // Marcar hijos como procesados para que no se agreguen
          selectedItems.forEach((child) => {
            if (child.level === 2 && child.parentId === item.id) {
              processed.add(child.id);
            }
          });
        } else if (item.level === 2) {
          // Es un sublote (hijo)
          const parentInSelection = selectedItems.find(
            (parent) => parent.id === item.parentId && parent.level === 1
          );

          if (!parentInSelection) {
            // No hay padre seleccionado, se puede agregar el hijo
            result.push(item);
            processed.add(item.id);
          } else {
            // Hay padre seleccionado, mostrar mensaje informativo
            if (!processed.has(item.parentId)) {
              this.$fun &&
                this.$fun.toast &&
                this.$fun.toast(
                  `Lote padre ya seleccionado. Se omite sublote: ${item.name}`,
                  "info"
                );
            }
          }
        }
      });

      return result;
    },

    updateMapMarkers() {
      this.markersLayer.clearLayers();

      // Agregar marcador de la planta si está en la ruta
      if (this.includeReturnTrip && this.routePoints.some((p) => p.id === "sunshine")) {
        const plantStartIndex = this.routePoints.findIndex((p) => p.id === "sunshine");
        const plantEndIndex = this.routePoints.findLastIndex
          ? this.routePoints.findLastIndex((p) => p.id === "sunshine")
          : this.routePoints.length -
            1 -
            [...this.routePoints].reverse().findIndex((p) => p.id === "sunshine");

        // Marcador de la planta (inicio/fin)
        const plantMarker = L.marker([this.sunshinePoint.lat, this.sunshinePoint.lng], {
          icon: L.divIcon({
            className: "plant-marker",
            html: `<div style="
              background: #4caf50;
              color: white;
              border-radius: 4px;
              width: 30px;
              height: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: bold;
              font-size: 14px;
              border: 2px solid white;
              box-shadow: 0 3px 6px rgba(0,0,0,0.4);
            ">🏭</div>`,
            iconSize: [30, 30],
            iconAnchor: [15, 15],
          }),
        });

        plantMarker.bindTooltip(
          `
          <strong>🏭 ${this.sunshinePoint.name}</strong><br/>
          <strong>Inicio: ${plantStartIndex + 1} | Fin: ${plantEndIndex + 1}</strong><br/>
          Punto de partida y regreso
        `,
          { sticky: true }
        );

        this.markersLayer.addLayer(plantMarker);
      }

      // Solo agregar marcadores de fundos seleccionados (o guardados si existen)
      const farmsForMarkers =
        this.savedFarms && this.savedFarms.length > 0
          ? this.savedFarms
          : this.selectedFarms;
      farmsForMarkers.forEach((farm) => {
        const hasCoords = farm.lat && farm.lng && farm.lat !== "" && farm.lng !== "";

        if (hasCoords) {
          const lat = parseFloat(farm.lat);
          const lng = parseFloat(farm.lng);

          if (!isNaN(lat) && !isNaN(lng)) {
            const selectedIndex = this.routePoints.findIndex(
              (point) => point.id === farm.fagId
            );
            const isInRoute = selectedIndex >= 0;

            if (isInRoute) {
              // Marcador numerado para fundos en la ruta (con número)
              const routeNumber = selectedIndex + 1;

              const numberIcon = L.divIcon({
                className: "route-number",
                html: `<div style="
                  background: ${farm.supervisorColor};
                  color: white;
                  border-radius: 50%;
                  width: 28px;
                  height: 28px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-weight: bold;
                  font-size: 14px;
                  border: 3px solid white;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.5);
                ">${routeNumber}</div>`,
                iconSize: [28, 28],
                iconAnchor: [14, 14],
              });

              const numberMarker = L.marker([lat, lng], { icon: numberIcon });

              numberMarker.bindTooltip(
                `
                <strong>${farm.name}</strong><br/>
                <strong>Orden en ruta: ${routeNumber}</strong><br/>
                Supervisor: ${this.getSupervisorName(farm.supervisorId)}<br/>
                Área lotes: ${farm.areaAll || 0} ha<br/>
                Lat: ${lat.toFixed(6)}<br/>
                Lng: ${lng.toFixed(6)}
              `,
                { sticky: true }
              );
              numberMarker.on("click", () => this.toggleFarmSelection(farm));

              this.markersLayer.addLayer(numberMarker);
            } else {
              // Marcador simple para fundos seleccionados pero sin ruta trazada
              const marker = L.circleMarker([lat, lng], {
                radius: 10,
                fillColor: farm.supervisorColor,
                color: "white",
                weight: 3,
                opacity: 1,
                fillOpacity: 0.8,
              });
              marker.on("click", () => this.toggleFarmSelection(farm));

              marker.bindTooltip(
                `
                <strong>${farm.name}</strong><br/>
                <em>Fundo seleccionado (presiona "Trazar Ruta")</em><br/>
                Supervisor: ${this.getSupervisorName(farm.supervisorId)}<br/>
                Área lotes: ${farm.areaAll || 0} ha<br/>
                Lat: ${lat.toFixed(6)}<br/>
                Lng: ${lng.toFixed(6)}
              `,
                { sticky: true }
              );

              this.markersLayer.addLayer(marker);
            }
          }
        }
      });

      // Ajustar vista solo si hay lotes seleccionados
      this.adjustMapViewToSelection();
    },

    // Calcular ruta principal (llamado por el botón)
    calculateRoute() {
      const baseSelection = this.getSelectionForRoute();
      if (baseSelection.length === 0) {
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("Selecciona al menos 1 fundo", "info");
        return;
      }

      // Usar el orden de selección del usuario (sin optimizar)
      this.calculateBasicRoute();
    },

    // Calcula ruta usando el orden de selección
    calculateBasicRoute() {
      const baseSelection = this.getSelectionForRoute();
      if (baseSelection.length === 0) {
        this.clearRoute();
        return;
      }

      // Convertir fundos seleccionados a puntos de ruta
      let points = baseSelection.map((farm) => ({
        id: farm.fagId,
        lat: farm.lat,
        lng: farm.lng,
        name: farm.name,
        isPlant: false,
        isFarm: true,
      }));

      // Incluir planta si está activado
      if (this.includeReturnTrip && baseSelection.length > 0) {
        // Añadir planta al inicio y al final para ida y vuelta
        points = [this.sunshinePoint, ...points, this.sunshinePoint];
      }

      this.routePoints = points;
      this.drawRoute();
    },

    // Optimiza la ruta usando algoritmo nearest neighbor
    async optimizeRoute() {
      const baseSelection = this.getSelectionForRoute();
      if (baseSelection.length === 0) {
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("Selecciona al menos 1 fundo", "info");
        return;
      }

      this.routeLoading = true;
      try {
        let points = baseSelection.map((farm) => ({
          id: farm.fagId,
          lat: farm.lat,
          lng: farm.lng,
          name: farm.name,
          isPlant: false,
          isFarm: true,
        }));

        let optimizedPoints;

        if (this.useRoadRouting) {
          // Pre-calcular matriz de distancias por carretera
          const allPoints = this.includeReturnTrip
            ? [this.sunshinePoint, ...points]
            : points;
          const distanceMatrix = await this.calculateDistanceMatrix(allPoints);

          if (this.includeReturnTrip) {
            if (points.length > 1) {
              optimizedPoints = this.nearestNeighborRouteFromPointWithMatrix(
                points,
                this.sunshinePoint,
                distanceMatrix
              );
            } else {
              optimizedPoints = points;
            }
            optimizedPoints = [
              this.sunshinePoint,
              ...optimizedPoints,
              this.sunshinePoint,
            ];
          } else {
            optimizedPoints = this.nearestNeighborRouteWithMatrix(points, distanceMatrix);
          }
        } else {
          // Usar distancias euclidianas (método original)
          if (this.includeReturnTrip) {
            if (points.length > 1) {
              optimizedPoints = this.nearestNeighborRouteFromPoint(
                points,
                this.sunshinePoint
              );
            } else {
              optimizedPoints = points;
            }
            optimizedPoints = [
              this.sunshinePoint,
              ...optimizedPoints,
              this.sunshinePoint,
            ];
          } else {
            optimizedPoints = this.nearestNeighborRoute(points);
          }
        }

        this.routePoints = optimizedPoints;
        await this.drawRoute();

        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast(`Ruta optimizada: ${this.routeInfo.distance} km`, "success");
      } catch (error) {
        console.error("Error optimizing route:", error);
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("Error al optimizar ruta", "error");
      } finally {
        this.routeLoading = false;
      }
    },

    // Selección efectiva para la ruta: usa guardados si existen, sino la selección actual
    getSelectionForRoute() {
      return this.savedFarms && this.savedFarms.length > 0
        ? this.savedFarms
        : this.selectedFarms;
    },

    // Algoritmo nearest neighbor para encontrar ruta más corta
    nearestNeighborRoute(points) {
      if (points.length <= 2) return points;

      const route = [points[0]];
      const remaining = [...points.slice(1)];

      while (remaining.length > 0) {
        const current = route[route.length - 1];
        let nearestIndex = 0;
        let shortestDistance = this.calculateDistance(current, remaining[0]);

        for (let i = 1; i < remaining.length; i++) {
          const distance = this.calculateDistance(current, remaining[i]);
          if (distance < shortestDistance) {
            shortestDistance = distance;
            nearestIndex = i;
          }
        }

        route.push(remaining[nearestIndex]);
        remaining.splice(nearestIndex, 1);
      }

      return route;
    },

    // Calcula matriz de distancias entre todos los puntos
    async calculateDistanceMatrix(points) {
      const matrix = {};
      const total = (points.length * (points.length - 1)) / 2;
      let calculated = 0;

      for (let i = 0; i < points.length; i++) {
        matrix[points[i].id] = {};

        for (let j = 0; j < points.length; j++) {
          if (i === j) {
            matrix[points[i].id][points[j].id] = 0;
          } else if (matrix[points[j].id] && matrix[points[j].id][points[i].id]) {
            // Usar distancia ya calculada (simétrica)
            matrix[points[i].id][points[j].id] = matrix[points[j].id][points[i].id];
          } else {
            try {
              const distance = await this.calculateDistance(points[i], points[j]);
              matrix[points[i].id][points[j].id] = distance;
              calculated++;

              if (calculated % 5 === 0) {
                console.log(`📈 Calculadas ${calculated}/${total} distancias...`);
              }
            } catch (error) {
              console.warn(`Error calculando distancia ${i}-${j}:`, error);
              matrix[points[i].id][points[j].id] = this.getEuclideanDistance(
                points[i],
                points[j]
              );
            }
          }
        }
      }
      return matrix;
    },

    // Nearest neighbor con matriz pre-calculada
    nearestNeighborRouteWithMatrix(points, distanceMatrix) {
      if (points.length <= 2) return points;

      const route = [points[0]];
      const remaining = [...points.slice(1)];

      while (remaining.length > 0) {
        const current = route[route.length - 1];
        let nearestIndex = 0;
        let shortestDistance = distanceMatrix[current.id][remaining[0].id];

        for (let i = 1; i < remaining.length; i++) {
          const distance = distanceMatrix[current.id][remaining[i].id];
          if (distance < shortestDistance) {
            shortestDistance = distance;
            nearestIndex = i;
          }
        }

        route.push(remaining[nearestIndex]);
        remaining.splice(nearestIndex, 1);
      }

      return route;
    },

    // Nearest neighbor desde punto específico con matriz
    nearestNeighborRouteFromPointWithMatrix(points, startPoint, distanceMatrix) {
      if (points.length <= 1) return points;

      const route = [];
      const remaining = [...points];
      let current = startPoint;

      while (remaining.length > 0) {
        let nearestIndex = 0;
        let shortestDistance = distanceMatrix[current.id][remaining[0].id];

        for (let i = 1; i < remaining.length; i++) {
          const distance = distanceMatrix[current.id][remaining[i].id];
          if (distance < shortestDistance) {
            shortestDistance = distance;
            nearestIndex = i;
          }
        }

        const nearest = remaining[nearestIndex];
        route.push(nearest);
        current = nearest;
        remaining.splice(nearestIndex, 1);
      }

      return route;
    },

    // Algoritmo nearest neighbor comenzando desde un punto especific
    nearestNeighborRouteFromPoint(points, startPoint) {
      if (points.length <= 1) return points;

      const route = [];
      const remaining = [...points];
      let current = startPoint;

      while (remaining.length > 0) {
        let nearestIndex = 0;
        let shortestDistance = this.calculateDistance(current, remaining[0]);

        for (let i = 1; i < remaining.length; i++) {
          const distance = this.calculateDistance(current, remaining[i]);
          if (distance < shortestDistance) {
            shortestDistance = distance;
            nearestIndex = i;
          }
        }

        const nearest = remaining[nearestIndex];
        route.push(nearest);
        current = nearest;
        remaining.splice(nearestIndex, 1);
      }

      return route;
    },

    // Calcula distancia entre dos puntos
    async calculateDistance(point1, point2) {
      if (this.useRoadRouting) {
        try {
          const roadRoute = await this.getRoadRoute(point1, point2);
          return roadRoute
            ? roadRoute.distance
            : this.getEuclideanDistance(point1, point2);
        } catch (error) {
          console.warn("Fallback a distancia euclidiana:", error);
          return this.getEuclideanDistance(point1, point2);
        }
      } else {
        return this.getEuclideanDistance(point1, point2);
      }
    },

    // Calcula distancia euclidiana (línea recta)
    getEuclideanDistance(point1, point2) {
      const from = L.latLng(point1.lat, point1.lng);
      const to = L.latLng(point2.lat, point2.lng);
      return from.distanceTo(to);
    },

    // Obtiene ruta por carretera entre dos puntos usando múltiples servicios (lógica de MapsSunExpert)
    async getRoadRoute(start, end) {
      try {
        // Formatear coordenadas para OSRM (lng,lat)
        const origen = `${start.lng},${start.lat}`;
        const destino = `${end.lng},${end.lat}`;

        const endpoints = [
          // OSRM oficial
          {
            name: "OSRM Official",
            url: `https://router.project-osrm.org/route/v1/driving/${origen};${destino}?overview=full&geometries=geojson&alternatives=false&steps=false`,
          },
          // Fallback OSM community
          {
            name: "OSM Routing",
            url: `https://routing.openstreetmap.de/routed-car/route/v1/driving/${origen};${destino}?overview=full&geometries=geojson&alternatives=false&steps=false`,
          },
          // GraphHopper (alternativo)
          {
            name: "GraphHopper",
            url: `https://graphhopper.com/api/1/route?point=${start.lat},${start.lng}&point=${end.lat},${end.lng}&vehicle=car&calc_points=true&type=json`,
          },
        ];

        for (const endpoint of endpoints) {
          try {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 segundos timeout

            const response = await fetch(endpoint.url, {
              method: "GET",
              mode: "cors",
              headers: {
                Accept: "application/json",
                "User-Agent": "SunExpert-RouteSelector/1.0",
              },
              signal: controller.signal,
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();

            let route = null;
            let distance = null;
            let geometry = null;
            let duration = null;

            // Procesar respuesta según el endpoint
            if (endpoint.name === "GraphHopper") {
              route = data.paths && data.paths[0];
              if (route) {
                distance = route.distance; // metros
                duration = route.time; // milisegundos
                geometry = route.points;
              }
            } else {
              // OSRM format
              route = data.routes && data.routes[0];
              if (route) {
                distance = route.distance; // metros
                duration = route.duration; // segundos
                geometry = route.geometry;
              }
            }

            if (!route || !distance || !geometry) {
              throw new Error("Respuesta inválida: no se encontró ruta");
            }

            // Procesar geometría según el tipo
            let coordinates;
            if (endpoint.name === "GraphHopper") {
              coordinates = this.decodePolyline(geometry);
            } else {
              // OSRM GeoJSON format
              coordinates = geometry.coordinates.map((coord) => [coord[1], coord[0]]); // [lng,lat] to [lat,lng]
            }

            return {
              coordinates: coordinates,
              distance: distance, // en metros
              duration: endpoint.name === "GraphHopper" ? duration / 1000 : duration, // convertir a segundos
              service: endpoint.name,
            };
          } catch (error) {
            console.warn(`⚠️ Error con ${endpoint.name}:`, error);

            if (error.name === "AbortError") {
              console.warn("⏱️ Timeout en la petición");
            }
            // Continuar con el siguiente endpoint
          }
        }

        throw new Error("Todos los servicios de routing fallaron");
      } catch (error) {
        console.error("Error obteniendo ruta:", error);
        throw error;
      }
    },

    // Método para decodificar polylines encoded (usado por GraphHopper)
    decodePolyline(encoded) {
      if (!encoded) return [];

      const poly = [];
      let index = 0;
      let lat = 0;
      let lng = 0;

      while (index < encoded.length) {
        let b,
          shift = 0,
          result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const deltaLat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += deltaLat;

        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        const deltaLng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += deltaLng;

        poly.push([lat / 1e5, lng / 1e5]);
      }
      return poly;
    },

    // Dibuja la ruta en el mapa
    async drawRoute() {
      this.routeLayer.clearLayers();

      if (this.routePoints.length < 2) {
        this.routeInfo = { distance: 0, estimatedTime: 0 };
        return;
      }

      if (this.useRoadRouting) {
        await this.drawRoadRoute();
      } else {
        this.drawStraightRoute();
      }

      // Actualizar marcadores para mostrar numeración
      this.updateMapMarkers();

      // Cargar polígonos con colores de ruta
      this.loadSelectedLotPolygons();

      // Ajustar vista del mapa para mostrar toda la ruta
      this.adjustMapViewToSelection();
    },

    // Dibuja ruta con líneas rectas
    drawStraightRoute() {
      const routeCoords = this.routePoints.map((p) => [p.lat, p.lng]);

      // Dibujar línea principal de la ruta
      const routeLine = L.polyline(routeCoords, {
        color: "#ff5722",
        weight: 4,
        opacity: 0.8,
        dashArray: "10, 5",
      });

      this.routeLayer.addLayer(routeLine);

      // Dibujar flechas direccionales
      this.drawDirectionArrows(routeCoords);

      // Calcular información de la ruta (distancia euclidiana)
      this.calculateRouteInfo(routeCoords);
    },

    // Dibuja ruta siguiendo carreteras
    async drawRoadRoute() {
      try {
        const segments = [];
        let totalDistance = 0;
        let totalDuration = 0;

        // Obtener ruta por segmentos
        for (let i = 0; i < this.routePoints.length - 1; i++) {
          const start = this.routePoints[i];
          const end = this.routePoints[i + 1];

          try {
            const segment = await this.getRoadRoute(start, end);
            if (segment) {
              segments.push(segment);
              totalDistance += segment.distance;
              totalDuration += segment.duration;

              // Dibujar segmento
              const polyline = L.polyline(segment.coordinates, {
                color: "#ff5722",
                weight: 4,
                opacity: 0.8,
              });

              this.routeLayer.addLayer(polyline);
            }
          } catch (segmentError) {
            console.warn(`⚠️ Error en segmento ${i}-${i + 1}:`, segmentError);
            // Fallback a línea recta para este segmento
            const straightLine = L.polyline(
              [
                [start.lat, start.lng],
                [end.lat, end.lng],
              ],
              {
                color: "#ff9800",
                weight: 3,
                opacity: 0.6,
                dashArray: "5, 5",
              }
            );
            this.routeLayer.addLayer(straightLine);
          }
        }

        // Actualizar información de ruta
        this.routeInfo = {
          distance: (totalDistance / 1000).toFixed(2),
          estimatedTime: Math.round(totalDuration / 60), // convertir a minutos
        };
      } catch (error) {
        console.error("❌ Error calculando ruta por carretera:", error);
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast(
            "Error al calcular ruta por carretera. Usando líneas rectas.",
            "warning"
          );

        // Fallback a ruta recta
        this.drawStraightRoute();
      }
    },

    // Dibuja flechas direccionales en la ruta
    drawDirectionArrows(routeCoords) {
      for (let i = 0; i < routeCoords.length - 1; i++) {
        const start = routeCoords[i];
        const end = routeCoords[i + 1];

        // Punto medio para colocar la flecha
        const midLat = (start[0] + end[0]) / 2;
        const midLng = (start[1] + end[1]) / 2;

        // Calcular ángulo de la flecha
        const angle =
          (Math.atan2(end[1] - start[1], end[0] - start[0]) * 180) / Math.PI + 90;

        const arrowIcon = L.divIcon({
          className: "route-arrow",
          html: `<div style="
            width: 0;
            height: 0;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-bottom: 16px solid #ff5722;
            transform: rotate(${angle}deg);
            opacity: 0.7;
          "></div>`,
          iconSize: [16, 16],
          iconAnchor: [8, 8],
        });

        const arrowMarker = L.marker([midLat, midLng], { icon: arrowIcon });
        this.routeLayer.addLayer(arrowMarker);
      }
    },

    // Calcula información de la ruta (distancia y tiempo estimado)
    calculateRouteInfo(routeCoords) {
      let totalDistance = 0;

      for (let i = 0; i < routeCoords.length - 1; i++) {
        const from = L.latLng(routeCoords[i]);
        const to = L.latLng(routeCoords[i + 1]);
        totalDistance += from.distanceTo(to);
      }

      const distanceKm = totalDistance / 1000;
      const estimatedTime = Math.round(distanceKm * 2); // 2 min por km (estimación)

      this.routeInfo = {
        distance: distanceKm.toFixed(2),
        estimatedTime: estimatedTime,
      };
    },

    clearAllSelections() {
      this.selectedFarmIds = [];
      this.selectedFarms = [];
      this.clearRoute();
      this.polygonsLayer.clearLayers();
      if (this.lotMarkersLayer) {
        this.lotMarkersLayer.clearLayers();
      }
      this.updateMapMarkers();
      this.updateMapFarmPolygons(); // Recargar polígonos
    },

    // Seleccionar todos los fundos visibles (según filtro actual)
    selectAllVisibleFarms() {
      const farms = [];
      const collect = (nodes) => {
        nodes.forEach((n) => {
          if (n.isSupervisor && n.children) {
            n.children.forEach((f) => {
              if (!f.isSupervisor) farms.push(f);
            });
          } else if (!n.isSupervisor) {
            farms.push(n);
          }
        });
      };
      collect(this.filteredTreeItems || []);
      // Eliminar duplicados por fagId
      const map = new Map();
      farms.forEach((f) => {
        map.set(f.fagId, f);
      });
      const unique = Array.from(map.values());
      this.selectedFarms = unique;
      this.selectedFarmIds = [...unique];
      this.updateMapMarkers();
      this.adjustMapViewToSelection();
      this.loadSelectedFarmPolygons();
      this.$fun &&
        this.$fun.toast &&
        this.$fun.toast(`Seleccionados ${unique.length} fundos visibles`, "success");
    },

    // Guardar selección actual en una lista persistente
    saveCurrentSelection() {
      const map = new Map(this.savedFarms.map((f) => [f.fagId, f]));
      this.selectedFarms.forEach((f) => map.set(f.fagId, f));
      this.savedFarms = Array.from(map.values());
      this.$fun &&
        this.$fun.toast &&
        this.$fun.toast(`Guardados ${this.savedFarms.length} fundos para ruta`, "info");
    },

    clearSavedSelection() {
      this.savedFarms = [];
      this.$fun && this.$fun.toast && this.$fun.toast("Guardados limpiados", "info");
    },

    // Ajusta la vista del mapa según los lotes seleccionados y/o ruta trazada
    adjustMapViewToSelection() {
      const pointsToShow = [];

      // Si hay ruta trazada, incluir todos los puntos de ruta
      if (this.routePoints.length > 0) {
        this.routePoints.forEach((point) => {
          pointsToShow.push([point.lat, point.lng]);
        });
      } else if (this.selectedFarms.length > 0) {
        // Si no hay ruta, solo mostrar fundos seleccionados
        this.selectedFarms.forEach((farm) => {
          if (farm.lat && farm.lng) {
            const lat = parseFloat(farm.lat);
            const lng = parseFloat(farm.lng);
            if (!isNaN(lat) && !isNaN(lng)) {
              pointsToShow.push([lat, lng]);
            }
          }
        });

        // Si está activado "Desde planta" agregar punto de la planta
        if (this.includeReturnTrip) {
          pointsToShow.push([this.sunshinePoint.lat, this.sunshinePoint.lng]);
        }
      }

      // Ajustar vista si hay puntos para mostrar
      if (pointsToShow.length > 0) {
        if (pointsToShow.length === 1) {
          // Solo un punto, centrar en él
          this.map.setView(pointsToShow[0], 14);
        } else {
          // Múltiples puntos, ajustar bounds
          const group = new L.featureGroup();
          pointsToShow.forEach((coords) => {
            group.addLayer(L.marker(coords));
          });

          this.map.fitBounds(group.getBounds(), {
            padding: [30, 30],
            maxZoom: 13, // No hacer zoom demasiado cercano
          });
        }
      } else {
        // No hay puntos, mantener vista centrada en la planta
        this.map.setView([this.sunshinePoint.lat, this.sunshinePoint.lng], this.mapZoom);
      }
    },

    recalculateRoute() {
      this.calculateBasicRoute();
      this.$fun && this.$fun.toast && this.$fun.toast("Ruta recalculada", "success");
    },

    clearRoute() {
      this.routeLayer.clearLayers();
      this.routePoints = [];
      this.routeInfo = { distance: 0, estimatedTime: 0 };
      this.updateMapMarkers();
      this.loadSelectedFarmPolygons(); // Actualizar colores de polígonos
      this.adjustMapViewToSelection();
    },

    // Utilidades de color para generar variantes (aclarar/oscurecer)
    normalizeHex(hex) {
      if (!hex) return "#2196f3";
      let h = String(hex).trim();
      if (h.startsWith("#")) h = h.slice(1);
      if (h.length === 3)
        h = h
          .split("")
          .map((c) => c + c)
          .join("");
      if (h.length !== 6) return "#2196f3";
      return `#${h}`;
    },
    clampChannel(v) {
      return Math.max(0, Math.min(255, Math.round(v)));
    },
    lightenColor(hex, amount = 20) {
      // amount: 0-100 (porcentaje hacia blanco)
      const norm = this.normalizeHex(hex).slice(1);
      const num = parseInt(norm, 16);
      const r = (num >> 16) & 0xff;
      const g = (num >> 8) & 0xff;
      const b = num & 0xff;
      const p = Math.max(0, Math.min(100, amount)) / 100;
      const nr = this.clampChannel(r + (255 - r) * p);
      const ng = this.clampChannel(g + (255 - g) * p);
      const nb = this.clampChannel(b + (255 - b) * p);
      return `#${((1 << 24) + (nr << 16) + (ng << 8) + nb).toString(16).slice(1)}`;
    },
    darkenColor(hex, amount = 20) {
      // amount: 0-100 (porcentaje hacia negro)
      const norm = this.normalizeHex(hex).slice(1);
      const num = parseInt(norm, 16);
      const r = (num >> 16) & 0xff;
      const g = (num >> 8) & 0xff;
      const b = num & 0xff;
      const p = Math.max(0, Math.min(100, amount)) / 100;
      const nr = this.clampChannel(r * (1 - p));
      const ng = this.clampChannel(g * (1 - p));
      const nb = this.clampChannel(b * (1 - p));
      return `#${((1 << 24) + (nr << 16) + (ng << 8) + nb).toString(16).slice(1)}`;
    },
  },

  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
  },
};
</script>

<style scoped>
.tree-label {
  font-size: 0.875rem;
}

#lotMap {
  min-height: 400px;
}

.v-treeview--dense .v-treeview-node__root {
  min-height: 32px;
}

/* Estilos globales para elementos del mapa */
:deep(.route-number) {
  background: transparent !important;
  border: none !important;
}

:deep(.route-arrow) {
  background: transparent !important;
  border: none !important;
}

/* Animación para chips de información */
.v-chip {
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}

/* Checkbox flotante sobre el polígono del fundo */
:deep(.farm-check-container) {
  pointer-events: auto;
}

:deep(.farm-check) {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

:deep(.farm-check input[type="checkbox"]) {
  cursor: pointer;
}

:deep(.farm-check.is-checked) {
  border-color: #1976d2;
}
</style>

<style>
/* Estilos para tooltips de polígonos de fundos */
.farm-polygon-tooltip {
  background-color: rgba(255, 255, 255, 0.95) !important;
  border: 2px solid #2196f3 !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-family: "Roboto", Arial, sans-serif !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25) !important;
  color: #333 !important;
}

.farm-polygon-tooltip::before {
  border-top-color: #2196f3 !important;
}

/* Estilos para tooltips de polígonos de lotes */
.lot-polygon-tooltip {
  background-color: rgba(255, 255, 255, 0.95) !important;
  border: 2px solid #43a047 !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-family: "Roboto", Arial, sans-serif !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25) !important;
  color: #333 !important;
}

.lot-polygon-tooltip::before {
  border-top-color: #43a047 !important;
}
</style>
